<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from '@dh-io-owpi/shared/src/plugins/i18n';
import SPASection from '@/components/SPASection.vue';
import UspModules from './components/UspModules.vue';
import UspDisclaimer from './components/UspDisclaimer.vue';
import { useUspHighlights } from './utils/SpaHighlight';

const uspFragments = useUspHighlights();
const i18n = useI18n();

// On USP section, show a footnote reference in the USP title if there is only a disclaimer footnote
const titleFootnotes = computed(() => {
  const disclaimerText = i18n.t('usp.disclaimer.text')?.trim();
  const disclaimerFootnote = i18n.t('usp.disclaimer.footnote')?.trim();
  if (!disclaimerText && disclaimerFootnote) {
    return [disclaimerFootnote];
  }
  return [];
});
</script>

<template>
  <SPASection name="usp" title :titleFootnotes>
    <section class="owpi-spa-usp">
      <UspModules :items="uspFragments" />
      <UspDisclaimer />
    </section>
  </SPASection>
</template>

<style lang="scss">
.owpi-spa-usp {
  $usp-ratio-height: 300px;
  min-height: $usp-ratio-height;

  @include wb.breakpoint-to(mq3) {
    min-height: calc($usp-ratio-height + 15vw);
  }

  // From MQ3 onwards, the wb-slider reduces the image height, to maintain an approximate height according to the viewport width we reduce the vw
  @include wb.breakpoint-from(mq3) {
    min-height: calc($usp-ratio-height + 5vw);
  }
}
</style>
